import "url-search-params-polyfill";
import "./common/utils/polyfills";
import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { APP_CODE, isFailure } from "@sportal/api";

import "./index.scss";
import "./styles/customizations/index.scss";

import { App } from "./App";
import makeStore from "./store";
import { Api } from "./api/api";
import {
  makeHttpService,
  makeAppConfigService,
  applyBusinessNameRequestHeader,
  applySessionExpirationInterceptor,
} from "./api/ssm";

async function initialize() {
  global.nominum = process.env.NOMINUM_INFO as any;

  const http = makeHttpService();
  const appConfigService = makeAppConfigService(http);
  const appConfigResult = await appConfigService.get();

  if (isFailure(appConfigResult)) {
    return;
  }

  const { data: appConfig } = appConfigResult;

  const api = new Api({
    ...appConfig,
    http,
    mode: APP_CODE.SB,
  });
  document.title = appConfig.appTitle;
  const store = makeStore({ api }, appConfig);

  applyBusinessNameRequestHeader(http, store);
  applySessionExpirationInterceptor(http, store);

  return {
    store,
  };
}

initialize().then((result) => {
  const container = document.getElementById("root");

  if (!result) {
    container.innerText = "Something went wrong";

    return;
  }

  const root = createRoot(container);

  root.render(
    <Provider store={result.store}>
      <App />
    </Provider>
  );
});
